import React from 'react'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'

import useLogin from 'shared/store/useLogin'
import { UserRoles } from 'shared/consts'

import Typography from '@mui/material/Typography'
import { SmsOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { StyledCard, LogoBox } from './styles'
import { ModalType } from '../../types'

interface Props {
   handleModalType: (type: ModalType) => void
}

export default function NonCoopCard({ handleModalType }: Props) {
   const { user } = useLogin()
   const { t } = useTranslation('WHOLESALERS')

   function handleOnClick() {
      if (
         user.roles.includes(UserRoles.ULTRA) ||
         user.roles.includes(UserRoles.NITRO) ||
         user.roles.includes(UserRoles.PRO)
      ) {
         handleModalType('new')
      }
   }

   return (
      <Grid size={{ xs: 12, sm: 4, md: 4, lg: 3, xl: 2 }}>
         <StyledCard onClick={handleOnClick}>
            <Box
               sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignItems: 'center',
               }}
            >
               <LogoBox>
                  <SmsOutlined sx={{ height: 25, width: 'auto' }} /> <Typography variant="h6">SMS Api</Typography>
               </LogoBox>
               {!user.roles.includes(UserRoles.ULTRA) &&
                  !user.roles.includes(UserRoles.NITRO) &&
                  !user.roles.includes(UserRoles.PRO) && (
                     <Typography variant="body1" color="red" fontWeight="bolder">
                        {t('smsApi.onlyInProAndUltra')}
                     </Typography>
                  )}
            </Box>
         </StyledCard>
      </Grid>
   )
}
